import { render, staticRenderFns } from "./didi_location_modal.vue?vue&type=template&id=05db051e&scoped=true&"
import script from "./didi_location_modal.vue?vue&type=script&lang=js&"
export * from "./didi_location_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05db051e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05db051e')) {
      api.createRecord('05db051e', component.options)
    } else {
      api.reload('05db051e', component.options)
    }
    module.hot.accept("./didi_location_modal.vue?vue&type=template&id=05db051e&scoped=true&", function () {
      api.rerender('05db051e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/didi/location/didi_location_modal.vue"
export default component.exports